import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
    selector: "app-dismiss-form",
    templateUrl: "./dismiss-form.component.html",
    styleUrls: ["../row-action/row-action.component.scss"],
    standalone: false
})
export class DismissFormComponent {
    @Input() recName: string = '';
    @Output() submit = new EventEmitter<{ sumissionType: string, submissionValue: string | undefined }>();
    
    formSubmitted: boolean = false;
    dismissalReason: string = '';

    constructor() { }

    submitDismissal() {
        this.formSubmitted = true;
        if (!this.dismissalReason) return; // Prevent submission if textarea is empty
        this.submit.emit({ sumissionType: "dismiss", submissionValue: this.dismissalReason });
        this.exitCover();
    }

    exitCover() {
        this.dismissalReason = '';
        this.submit.emit({ sumissionType: "close", submissionValue: undefined });
    }
}